module.exports = __webpack_public_path__ + "static/media/ecosystems.dabf3be4.svg";